module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/domofon-1-6d534e3023b64ddc1052d4b90bc9c492.webp";